import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {
  Tenant,
  TenantUpdateReq,
  Tenants,
  TenantSendInviteReq,
  SendInviteCallbackReq,
  TenantSendInviteRsp,
  TenantBulkImportResult,
  TenantUpdateCallMethodReq,
  TenantUpdateCallMethodRsp,
  TenantBatchUpdateCallMethodReq,
  TenantBatchUpdateCallMethodRsp,
} from '../types/tenant';

/**
 * TenantServiceApi - axios parameter creator
 * @export
 */
export const TenantServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 租户创建
     * @summary 租户创建
     * @param {Tenant} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceCreate: async (
      tenant: Tenant,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists('tenantServiceCreate', 'tenant', tenant);
      const localVarPath = `/tenant/tenant`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenant,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tenantServiceDelete', 'id', id);
      const localVarPath = `/tenant/tenant/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户详情
     * @summary 租户详情
     * @param {string} id
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceDetail: async (
      id: string,
      userId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tenantServiceDetail', 'id', id);
      const localVarPath = `/tenant/tenant/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户列表查询
     * @summary 租户列表查询
     * @param {string} [name]
     * @param {string} [apartmentId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceFind: async (
      name?: string,
      apartmentId?: string,
      pageSize?: number,
      pageNum?: number,
      orgId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/tenant/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (apartmentId !== undefined) {
        localVarQueryParameter['apartmentId'] = apartmentId;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['page.size'] = pageSize;
      }

      if (pageNum !== undefined) {
        localVarQueryParameter['page.num'] = pageNum;
      }

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户邀请
     * @summary 租户邀请
     * @param {TenantSendInviteReq} tenantSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceSendInvite: async (
      tenantSendInviteReq: TenantSendInviteReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tenantSendInviteReq' is not null or undefined
      assertParamExists('tenantServiceSendInvite', 'tenantSendInviteReq', tenantSendInviteReq);
      const localVarPath = `/tenant/tenants/invite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantSendInviteReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户邀请回调
     * @summary 租户邀请回调
     * @param {string} id
     * @param {SendInviteCallbackReq} sendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceSendInviteCallback: async (
      id: string,
      sendInviteCallbackReq: SendInviteCallbackReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tenantServiceSendInviteCallback', 'id', id);
      // verify required parameter 'sendInviteCallbackReq' is not null or undefined
      assertParamExists(
        'tenantServiceSendInviteCallback',
        'sendInviteCallbackReq',
        sendInviteCallbackReq
      );
      const localVarPath = `/tenant/tenant/{id}/invite_callback`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendInviteCallbackReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户修改信息
     * @summary 租户修改信息
     * @param {string} id
     * @param {TenantUpdateReq} tenantUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceUpdate: async (
      id: string,
      tenantUpdateReq: TenantUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tenantServiceUpdate', 'id', id);
      // verify required parameter 'tenantUpdateReq' is not null or undefined
      assertParamExists('tenantServiceUpdate', 'tenantUpdateReq', tenantUpdateReq);
      const localVarPath = `/tenant/tenant/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    tenantServiceBulkImport: async (
      formData: FormData,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/tenant/tenants/bulk-import`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = formData;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update single tenant call method
     * @summary Update single tenant call method
     * @param {string} tenantId
     * @param {TenantUpdateCallMethodReq} tenantUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceUpdateCallMethod: async (
      tenantId: string,
      tenantUpdateCallMethodReq: TenantUpdateCallMethodReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('tenantServiceUpdateCallMethod', 'tenantId', tenantId);
      assertParamExists(
        'tenantServiceUpdateCallMethod',
        'tenantUpdateCallMethodReq',
        tenantUpdateCallMethodReq
      );
      const localVarPath = `/tenant/tenant/{tenantId}/call-method`.replace(
        `{${'tenantId'}}`,
        encodeURIComponent(String(tenantId))
      );
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantUpdateCallMethodReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Batch update tenant call method
     * @summary Batch update tenant call method
     * @param {TenantBatchUpdateCallMethodReq} tenantBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceBatchUpdateCallMethod: async (
      tenantBatchUpdateCallMethodReq: TenantBatchUpdateCallMethodReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists(
        'tenantServiceBatchUpdateCallMethod',
        'tenantBatchUpdateCallMethodReq',
        tenantBatchUpdateCallMethodReq
      );
      const localVarPath = `/tenant/tenants/call-method`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tenantBatchUpdateCallMethodReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantServiceApi - functional programming interface
 * @export
 */
export const TenantServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 租户创建
     * @summary 租户创建
     * @param {Tenant} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceCreate(
      tenant: Tenant,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceCreate(
        tenant,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户详情
     * @summary 租户详情
     * @param {string} id
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceDetail(
      id: string,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceDetail(
        id,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceDetail']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户列表查询
     * @summary 租户列表查询
     * @param {string} [name]
     * @param {string} [apartmentId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceFind(
      name?: string,
      apartmentId?: string,
      pageSize?: number,
      pageNum?: number,
      orgId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenants>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceFind(
        name,
        apartmentId,
        pageSize,
        pageNum,
        orgId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceFind']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户邀请
     * @summary 租户邀请
     * @param {TenantSendInviteReq} tenantSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceSendInvite(
      tenantSendInviteReq: TenantSendInviteReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSendInviteRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceSendInvite(
        tenantSendInviteReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceSendInvite']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户邀请回调
     * @summary 租户邀请回调
     * @param {string} id
     * @param {SendInviteCallbackReq} sendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceSendInviteCallback(
      id: string,
      sendInviteCallbackReq: SendInviteCallbackReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceSendInviteCallback(
        id,
        sendInviteCallbackReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceSendInviteCallback']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户修改信息
     * @summary 租户修改信息
     * @param {string} id
     * @param {TenantUpdateReq} tenantUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceUpdate(
      id: string,
      tenantUpdateReq: TenantUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceUpdate(
        id,
        tenantUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    async tenantServiceBulkImport(
      formData: FormData,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBulkImportResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceBulkImport(
        formData,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceBulkImport']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Update single tenant call method
     * @summary Update single tenant call method
     * @param {string} tenantId
     * @param {TenantUpdateCallMethodReq} tenantUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceUpdateCallMethod(
      tenantId: string,
      tenantUpdateCallMethodReq: TenantUpdateCallMethodReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantUpdateCallMethodRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceUpdateCallMethod(
        tenantId,
        tenantUpdateCallMethodReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceUpdateCallMethod']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Batch update tenant call method
     * @summary Batch update tenant call method
     * @param {TenantBatchUpdateCallMethodReq} tenantBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantServiceBatchUpdateCallMethod(
      tenantBatchUpdateCallMethodReq: TenantBatchUpdateCallMethodReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBatchUpdateCallMethodRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantServiceBatchUpdateCallMethod(
        tenantBatchUpdateCallMethodReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TenantServiceApi.tenantServiceBatchUpdateCallMethod']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TenantServiceApi - factory interface
 * @export
 */
export const TenantServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantServiceApiFp(configuration);
  return {
    /**
     * 租户创建
     * @summary 租户创建
     * @param {Tenant} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceCreate(tenant: Tenant, options?: any): AxiosPromise<void> {
      return localVarFp
        .tenantServiceCreate(tenant, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.tenantServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 租户详情
     * @summary 租户详情
     * @param {string} id
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceDetail(id: string, userId?: string, options?: any): AxiosPromise<Tenant> {
      return localVarFp
        .tenantServiceDetail(id, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户列表查询
     * @summary 租户列表查询
     * @param {string} [name]
     * @param {string} [apartmentId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceFind(
      name?: string,
      apartmentId?: string,
      pageSize?: number,
      pageNum?: number,
      orgId?: string,
      options?: any
    ): AxiosPromise<Tenants> {
      return localVarFp
        .tenantServiceFind(name, apartmentId, pageSize, pageNum, orgId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户邀请
     * @summary 租户邀请
     * @param {TenantSendInviteReq} tenantSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceSendInvite(
      tenantSendInviteReq: TenantSendInviteReq,
      options?: any
    ): AxiosPromise<TenantSendInviteRsp> {
      return localVarFp
        .tenantServiceSendInvite(tenantSendInviteReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户邀请回调
     * @summary 租户邀请回调
     * @param {string} id
     * @param {SendInviteCallbackReq} sendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceSendInviteCallback(
      id: string,
      sendInviteCallbackReq: SendInviteCallbackReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .tenantServiceSendInviteCallback(id, sendInviteCallbackReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户修改信息
     * @summary 租户修改信息
     * @param {string} id
     * @param {TenantUpdateReq} tenantUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceUpdate(
      id: string,
      tenantUpdateReq: TenantUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .tenantServiceUpdate(id, tenantUpdateReq, options)
        .then(request => request(axios, basePath));
    },
    tenantServiceBulkImport(
      formData: FormData,
      options?: any
    ): AxiosPromise<TenantBulkImportResult> {
      return localVarFp
        .tenantServiceBulkImport(formData, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Update single tenant call method
     * @summary Update single tenant call method
     * @param {string} tenantId
     * @param {TenantUpdateCallMethodReq} tenantUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceUpdateCallMethod(
      tenantId: string,
      tenantUpdateCallMethodReq: TenantUpdateCallMethodReq,
      options?: any
    ): AxiosPromise<TenantUpdateCallMethodRsp> {
      return localVarFp
        .tenantServiceUpdateCallMethod(tenantId, tenantUpdateCallMethodReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Batch update tenant call method
     * @summary Batch update tenant call method
     * @param {TenantBatchUpdateCallMethodReq} tenantBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantServiceBatchUpdateCallMethod(
      tenantBatchUpdateCallMethodReq: TenantBatchUpdateCallMethodReq,
      options?: any
    ): AxiosPromise<TenantBatchUpdateCallMethodRsp> {
      return localVarFp
        .tenantServiceBatchUpdateCallMethod(tenantBatchUpdateCallMethodReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * TenantServiceApi - object-oriented interface
 * @export
 * @class TenantServiceApi
 * @extends {BaseAPI}
 */
export class TenantServiceApi extends BaseAPI {
  /**
   * 租户创建
   * @summary 租户创建
   * @param {Tenant} tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceCreate(tenant: Tenant, options?: RawAxiosRequestConfig) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceCreate(tenant, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户删除
   * @summary 租户删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户详情
   * @summary 租户详情
   * @param {string} id
   * @param {string} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceDetail(id: string, userId?: string, options?: RawAxiosRequestConfig) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceDetail(id, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户列表查询
   * @summary 租户列表查询
   * @param {string} [name]
   * @param {string} [apartmentId]
   * @param {number} [pageSize] 当前分页大小
   * @param {number} [pageNum] 当前页数
   * @param {string} [orgId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceFind(
    name?: string,
    apartmentId?: string,
    pageSize?: number,
    pageNum?: number,
    orgId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceFind(name, apartmentId, pageSize, pageNum, orgId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户邀请
   * @summary 租户邀请
   * @param {TenantSendInviteReq} tenantSendInviteReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceSendInvite(
    tenantSendInviteReq: TenantSendInviteReq,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceSendInvite(tenantSendInviteReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户邀请回调
   * @summary 租户邀请回调
   * @param {string} id
   * @param {SendInviteCallbackReq} sendInviteCallbackReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceSendInviteCallback(
    id: string,
    sendInviteCallbackReq: SendInviteCallbackReq,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceSendInviteCallback(id, sendInviteCallbackReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户修改信息
   * @summary 租户修改信息
   * @param {string} id
   * @param {TenantUpdateReq} tenantUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceUpdate(
    id: string,
    tenantUpdateReq: TenantUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceUpdate(id, tenantUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  public tenantServiceBulkImport(formData: FormData, options?: RawAxiosRequestConfig) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceBulkImport(formData, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Update single tenant call method
   * @summary Update single tenant call method
   * @param {string} tenantId
   * @param {TenantUpdateCallMethodReq} tenantUpdateCallMethodReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceUpdateCallMethod(
    tenantId: string,
    tenantUpdateCallMethodReq: TenantUpdateCallMethodReq,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceUpdateCallMethod(tenantId, tenantUpdateCallMethodReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Batch update tenant call method
   * @summary Batch update tenant call method
   * @param {TenantBatchUpdateCallMethodReq} tenantBatchUpdateCallMethodReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantServiceApi
   */
  public tenantServiceBatchUpdateCallMethod(
    tenantBatchUpdateCallMethodReq: TenantBatchUpdateCallMethodReq,
    options?: RawAxiosRequestConfig
  ) {
    return TenantServiceApiFp(this.configuration)
      .tenantServiceBatchUpdateCallMethod(tenantBatchUpdateCallMethodReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
